'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import Icon from "material-ui-icons/SettingsOverscan";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

var _reactRouterDom = require('react-router-dom');

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _Route = require('../Route');

var _Route2 = _interopRequireDefault(_Route);

var _context = require('../../../../context');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import PrismaCmsPerformanceTester from "@prisma-cms/performance";


var EditorSwitch = (_temp = _class = function (_EditorComponent) {
  _inherits(EditorSwitch, _EditorComponent);

  function EditorSwitch() {
    _classCallCheck(this, EditorSwitch);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  } // prepareDragItemComponents() {
  //   return super.prepareDragItemComponents().concat([
  //     {
  //       name: "EditorRoute",
  //       component: "EditorRoute",
  //       props: {
  //         path: "/",
  //         exact: true,
  //       },
  //       components: [],
  //     }
  //   ]);
  // }
  // onDrop(event) {
  //   const {
  //     dragItem,
  //     dragTarget,
  //   } = this.getEditorContext();
  //   if (dragItem && dragTarget && dragTarget === this) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     const {
  //       name,
  //     } = dragItem;
  //     /**
  //      * Позволяем добавить только роутеры
  //      */
  //     if (name !== "EditorRoute") {
  //       return false;
  //     }
  //   }
  //   return super.onDrop(event);
  // }

  /**
   * Не может быть дочерним для другого роутера
   */


  EditorSwitch.prototype.canBeChild = function canBeChild(child) {
    return child instanceof _Route2.default && _EditorComponent.prototype.canBeChild.call(this, child);
  };

  EditorSwitch.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'Router Switch'));
  }; // renderMainView() {
  //   const {
  //     inEditMode,
  //   } = this.getEditorContext();
  //   return inEditMode ? super.renderMainView() : this.renderChildren();
  // }


  EditorSwitch.prototype.renderItems = function renderItems(_ref) {
    var _this2 = this;

    var itemComponents = _ref.itemComponents,
        menuItems = _ref.menuItems,
        output = _ref.output,
        Components = _ref.Components,
        showRoutes = _ref.showRoutes,
        createTemplate = _ref.createTemplate,
        updateTemplate = _ref.updateTemplate,
        routesShowed = _ref.routesShowed;
    var Grid = this.context.Grid;
    itemComponents.map(function (n, index) {
      var id = n.id,
          name = n.name,
          props = n.props,
          other = _objectWithoutProperties(n, ['id', 'name', 'props']);

      var exact = props.exact,
          path = props.path,
          routername = props.routername;
      var Component = Components.find(function (n) {
        return n.Name === name;
      });

      if (Component) {
        var component = void 0;

        var route = _react2.default.createElement(_reactRouterDom.Route, {
          key: id || index,
          exact: exact === undefined ? false : exact,
          path: path,
          render: function render(routerProps) {
            /**
            ToDo: Удалить routerProps, потому что передает каждый раз новый объект
            и Роуты перерендериваются
             */
            return _react2.default.createElement(_context.RouteContext.Provider, {
              value: routerProps
            }, _react2.default.createElement(Component // key={id || index}
            , _extends({
              mode: 'main' // component={n}
              ,
              parent: _this2,
              props: props // data={{
              //   object: n,
              // }}
              ,
              object: n,
              exact: exact,
              path: path,
              routername: routername // _dirty={n}
              ,
              showRoutes: showRoutes,
              createTemplate: createTemplate,
              updateTemplate: updateTemplate
            }, other, props, routerProps)));
          }
        });
        /**
         * Если в режиме редактирования и показывать роутеры, то выводим данные
         */
        // if (inEditMode && showRoutes) {


        if (routesShowed) {
          var key = id + '-' + index;

          var title = _react2.default.createElement(_Typography2.default, null, routername, ' ', _react2.default.createElement(_Typography2.default, {
            component: 'span',
            variant: 'caption',
            style: {
              display: "inline-block"
            }
          }, path, !exact ? "*" : ""));

          component = _react2.default.createElement(_react.Fragment, {
            key: key
          }, title, route);
          menuItems.push(_react2.default.createElement(Grid, {
            key: key,
            item: true
          }, title));
        } else {
          // component = <Route
          //   key={id || index}
          //   exact={exact === undefined ? true : exact}
          //   path={path}
          //   render={() => {
          //     return element;
          //   }}
          // />
          component = route;
        }

        output.push(component);
      }
    });
  };

  EditorSwitch.prototype.renderChildren = function renderChildren() {
    var Grid = this.context.Grid;

    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    var _props = this.props,
        mutate = _props.mutate,
        createTemplate = _props.createTemplate,
        updateTemplate = _props.updateTemplate;

    var _getComponentProps = this.getComponentProps(this),
        showRoutes = _getComponentProps.showRoutes;

    var _getRenderProps = this.getRenderProps();

    _objectDestructuringEmpty(_getRenderProps);

    var object = this.getObjectWithMutations(); // const {
    //   // Components,
    //   // components,
    //   updateObject,
    // } = this.context;
    // const Components = this.getComponents();

    var _getEditorContext3 = this.getEditorContext(),
        Components = _getEditorContext3.Components;

    var props = object.props,
        itemComponents = object.components;
    var output = [];
    var header = void 0;
    var routesShowed = inEditMode && showRoutes;

    if (itemComponents) {
      var menuItems = [];
      this.renderItems({
        itemComponents: itemComponents,
        menuItems: menuItems,
        output: output,
        Components: Components,
        showRoutes: showRoutes,
        createTemplate: createTemplate,
        updateTemplate: updateTemplate,
        routesShowed: routesShowed
      });
      header = _react2.default.createElement(Grid, {
        container: true,
        spacing: 16
      }, menuItems);
    }

    var result = null;

    if (routesShowed) {
      result = _react2.default.createElement(_react.Fragment, null, header, output);
    } else {
      result = _react2.default.createElement(_reactRouterDom.Switch, null, output);
    } // return <Fragment>
    //   <PrismaCmsPerformanceTester
    //     props={this.props}
    //     state={this.state}
    //     context={this.context}
    //     prefix="switch_performance"
    //   />
    //   {result}
    // </Fragment>


    return result;
  };

  return EditorSwitch;
}(_2.default), _class.Name = "EditorSwitch", _class.propTypes = _extends({}, _2.default.propTypes, {
  showRoutes: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  showRoutes: true,
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = EditorSwitch;
module.exports = exports['default'];